// Utility functions for pull-to-load functionality

/**
 * Check if fulltext search tab is currently active
 * @returns {boolean} True if fulltext tab is active
 */
export function isFulltextTabActive() {
    const fulltextTabBtn = document.getElementById('nav-full-text-card-tab');
    if (!fulltextTabBtn) return false;
    // Check if tab button has 'active' class (Bootstrap 5)
    return fulltextTabBtn.classList.contains('active');
}

/**
 * Check if user is at bottom of page, accounting for mobile browser UI
 * Uses multiple methods for accurate detection across different browsers
 * @param {number} threshold - Distance threshold in pixels (default: 50)
 * @returns {boolean} True if at bottom of page
 */
export function isAtBottomOfPage(threshold = 50) {
    const documentHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
    );
    const scrollTop = window.pageYOffset || 
                      document.documentElement.scrollTop || 
                      document.body.scrollTop;
    
    // Primary method: use window.innerHeight (works reliably on desktop and mobile)
    const windowHeight = window.innerHeight;
    const distanceFromBottom = documentHeight - (scrollTop + windowHeight);
    const isAtBottomPrimary = distanceFromBottom <= threshold;
    
    // On mobile: check visualViewport API if available and significantly different
    // This accounts for browser UI (address bar, etc.) that affects viewport
    if (window.visualViewport) {
        const viewportHeight = window.visualViewport.height;
        const viewportOffsetTop = window.visualViewport.offsetTop || 0;
        const viewportDiff = Math.abs(viewportHeight - windowHeight);
        
        // If viewport differs significantly (mobile browser UI is affecting it)
        if (viewportDiff > 50) {
            // Mobile: use visualViewport method for accuracy
            const visibleBottom = scrollTop + viewportHeight + viewportOffsetTop;
            const viewportDistanceFromBottom = documentHeight - visibleBottom;
            return viewportDistanceFromBottom <= threshold;
        }
    }
    
    // Desktop or no visualViewport: use primary method
    return isAtBottomPrimary;
}

